import { render, staticRenderFns } from "./ManagementTeamInvite.vue?vue&type=template&id=68b25262&"
import script from "./ManagementTeamInvite.vue?vue&type=script&lang=js&"
export * from "./ManagementTeamInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports